import { createElementBlock as n, openBlock as o, createElementVNode as l } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(c, e) {
  return o(), n("svg", r, [...e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      d: "M12 12.75a2.25 2.25 0 1 1 0-4.5 2.25 2.25 0 0 1 0 4.5"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M17.834 16.039 12 21.75l-5.834-5.712a8.03 8.03 0 0 1-2.257-4.135 7.9 7.9 0 0 1 .469-4.667 8.1 8.1 0 0 1 3.039-3.625A8.38 8.38 0 0 1 12 2.25c1.632 0 3.227.474 4.583 1.361a8.1 8.1 0 0 1 3.039 3.625 7.9 7.9 0 0 1 .47 4.667 8.03 8.03 0 0 1-2.258 4.135m-1.05-1.072L12 19.65l-4.784-4.684a6.53 6.53 0 0 1-1.838-3.363 6.4 6.4 0 0 1 .381-3.783 6.6 6.6 0 0 1 2.479-2.954A6.88 6.88 0 0 1 12 3.75c1.342 0 2.651.39 3.762 1.117a6.6 6.6 0 0 1 2.479 2.954 6.4 6.4 0 0 1 .38 3.783 6.53 6.53 0 0 1-1.837 3.363",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const a = { render: t };
export {
  a as default,
  t as render
};
